module.exports = __webpack_public_path__ + "media/assets/background-images/app-logo-adef0d1a5abeb22e7ed4dfa28b964778.png";